import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Divider, Button, TextField, IconButton, makeStyles, FormControlLabel, Switch } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { useLocation, useNavigate } from 'react-router-dom';
import { Add, Remove } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { CreatePMLogs, getPM_planbyId, getPMLogByPlanId, updatePMLogs } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const useStyles = makeStyles((theme) => ({
    quantityBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #ccc',
        borderRadius: '8px',
        padding: theme.spacing(1),
    },
    iconButton: {
        backgroundColor: '#f0f0f0', // Background color for the icons
        '&:hover': {
            backgroundColor: '#e0e0e0',
        },
    },
    quantity: {
        backgroundColor: '#ffffff', // Background color for the quantity
        padding: theme.spacing(0, 2),
        borderRadius: '4px',
        margin: '0 10px',
    },
}));

const CheckPointActivity = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Preventive Maintenance', href: '/preventive-maintenance' },
        { label: 'Plan Overview', href: '/plan-overview' }
    ];
    const pathname = location.pathname.split('/');
    const plan_id = pathname[2]
    const Asset_id = pathname[3]
    const plan_date = pathname[4]

    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("00:00");
    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("00:00");


    const [loading, setLoading] = useState(true);
    const [defaultCheckpoints, setDefaultCheckpoints] = useState([]);
    const [log_ids, setlog_ids] = useState([]);
    const [checkpoints, setCheckpoints] = useState([]);
    const [quantity, setQuantity] = useState(0);
    const [submitAllOk, setsubmitAllOk] = useState(false);
    const [carriedOutName, setcarriedOutName] = useState('');
    const [formData, setFormData] = useState({
        frequency: "",
        startDate: "",
        assetNo: "",
        assetDes: "",
        partNo: ""
    });

    const handleIncrease = () => {
        setQuantity(quantity + 1);
    };

    const handleDecrease = () => {
        if (quantity > 0) {
            setQuantity(quantity - 1);
        }
    };
    const addRow = () => {
        setCheckpoints([...checkpoints, { type: '', name: '', value: '' }]);
    };

    const handleChange = (index, field, value) => {
        const updatedCheckpoints = checkpoints.map((checkpoint, i) => (
            i === index ? { ...checkpoint, [field]: value } : checkpoint
        ));
        setCheckpoints(updatedCheckpoints);
    };

    const handleDelete = (index) => {
        setCheckpoints(checkpoints.filter((_, i) => i !== index));
    };

    const checkpointHandler = (item) => {
        navigate(`/checkpoint-details/${item.checkpoint_id}/${plan_id}/${Asset_id}/${plan_date}`)
    }

    const formatDate = (date) => {
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
    };

    const submitHandler = async () => {
        if (submitAllOk) {
            // const checkpointData = defaultCheckpoints.map(cp => ({
            //     id: cp.checkpoint_id,
            //     ok: true
            // }));
            const checkpointData = defaultCheckpoints
                .filter(cp => !cp.log_time)  // Filters out checkpoints that have a log_time
                .map(cp => ({
                    id: cp.checkpoint_id,
                    ok: true
                }));
            if (checkpointData.length === 0) {
                toast.error("Checkpoints already logged!")
                return
            }
            const payload = {
                auto_ok: submitAllOk,
                done_by: carriedOutName,
                done_time_slots: {
                    start_date: formatDate(startDate),
                    start_time: startTime,
                    end_date: formatDate(endDate),
                    end_time: endTime
                },
                asset_id: Asset_id,
                start_time: `${formatDate(startDate)} ${startTime}:00`, // Reformat date and combine with time
                end_time: `${formatDate(endDate)} ${endTime}:00`,       // Reformat date and combine with time
                checkpoints: checkpointData
            };
            try {
                const action = dispatch(CreatePMLogs(payload));
                const res = await action.unwrap();
                if (res.StatusCode === 201) {
                    getlogs();
                    toast.success("Checkpoint Done");

                    const payload2 = {
                        log_ids: res.result.pm_log.map(item => item.id),
                        done_by: carriedOutName,
                        status: "submitted",
                        start_time: `${formatDate(startDate)} ${startTime}:00`,
                        end_time: `${formatDate(endDate)} ${endTime}:00`
                    };

                    try {
                        const action = dispatch(updatePMLogs(payload2));
                        const res2 = await action.unwrap();
                        console.log("response", res2);
                        if (res2.StatusCode === 201) {
                            toast.success("PM Logs Updated");
                            setTimeout(() => {
                                navigate("/plan-overview")
                            }, 2000);
                        } else {
                            toast.error("Something went wrong");
                        }

                    } catch (error) {
                        toast.error(error.message || "Something went Wrong!");
                    }


                } else {
                    toast.error(res.Message || "Something went wrong!");
                }
            } catch (error) {
                toast.error(error.message || "Failed to create PM log!");
            }
        } else {
            if (!log_ids.length && !submitAllOk) {
                toast.error("No checkpoint found to submit");
                return;
            }
            const log_id = defaultCheckpoints
                .filter(item => item && item.id && item.status !== 'submitted')  // Filter out null/undefined items and those with status 'submitted'
                .map(item => item.id);
            if (log_id.length === 0) {
                toast.error("Checkpoints already submitted!")
                return
            }
            const payload = {
                auto_ok: submitAllOk,
                done_by: carriedOutName,
                done_time_slots: {
                    start_date: formatDate(startDate),
                    start_time: startTime,
                    end_date: formatDate(endDate),
                    end_time: endTime
                },
                machine_id: Asset_id,
                start_time: `${formatDate(startDate)} ${startTime}:00`, // Reformat date and combine with time
                end_time: `${formatDate(endDate)} ${endTime}:00`,       // Reformat date and combine with time
                // log_ids: defaultCheckpoints
                //     .filter(item => item && item.id && item.status !== 'submitted')
                //     .map(item => item.id),
                log_ids: log_id,
                status: "submitted"
            };
            try {
                const action = dispatch(updatePMLogs(payload));
                const res = await action.unwrap();
                console.log("response", res);
                if (res.StatusCode === 201) {
                    toast.success("PM Logs Updated");
                    setTimeout(() => {
                        navigate("/plan-overview")
                    }, 2000);
                } else {
                    toast.error("Something went wrong");
                }

            } catch (error) {
                toast.error(error.message || "Something went Wrong!");
            }
        }
    };

    const getPlanbyId = async () => {
        try {
            const action = dispatch(getPM_planbyId(plan_id));
            const res = await action.unwrap();
            if (res.result) {
                // setplan(res.result.pm_plan[0]);
                setFormData({
                    ...formData,
                    frequency: res.result.pm_plan[0].frequency,
                    startDate: res.result.pm_plan[0].start_date,
                    assetNo: res.result.pm_plan[0].assetMaster_details.asset_no,
                    assetDes: res.result.pm_plan[0].assetMaster_details.asset_text,
                    partNo: res.result.pm_plan[0].assetMaster_details.part_no

                });
            };
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    }

    const getlogs = async () => {
        try {
            const action = dispatch(getPMLogByPlanId({ plan_id: plan_id, plan_date: plan_date }));
            const res = await action.unwrap();
            console.log("log response:", res);
            if (res.result && res.result.pm_logs) {
                // Extract IDs from the logs
                const ids = res.result.pm_logs
                    .filter(log => log.id) // Check if the log has an id
                    .map(log => log.id);   // Extract the id

                // Update the log_ids state with the extracted ids
                setlog_ids(ids);
            }
            setDefaultCheckpoints(res.result.pm_logs);

        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getPlanbyId();
            await getlogs();
            setLoading(false);
        };
        fetchData();
    }, [plan_id]);

    // useEffect(() => {
    //     dispatch(getPMCheckpoints(plan_id));
    // }, [plan_id])

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Checkpoint Activity
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Checkpoint Activity" />
                </Box>
                <Box mb={2}>
                    <h2> {formData.assetDes} ({(formData.assetNo)?.slice(3)})</h2>
                    <div className="checkpoint-box">
                        <Grid container spacing={3} className="checkpoint-header">
                            <Grid item xs={2}>
                                <h3>Sr.No.</h3>
                            </Grid>
                            <Grid item xs={6}>
                                <h3>Checkpoints</h3>
                            </Grid>
                            <Grid item xs={3}>
                                <h3>Status</h3>
                            </Grid>
                        </Grid>
                        <Divider />
                        {defaultCheckpoints && defaultCheckpoints.map((item, index) => (
                            <React.Fragment key={index}>
                                <Grid container spacing={3} className="checkpoint-item">
                                    <Grid item xs={2}>
                                        {index + 1}
                                    </Grid>
                                    <Grid item xs={6} onClick={() => checkpointHandler(item)} style={{ cursor: 'pointer' }}>
                                        {item.check_point}
                                    </Grid>
                                    <Grid item xs={3}>
                                        {/* {item.status} */}
                                        {item.hasOwnProperty('point_ok')
                                            ? (item.point_ok ? 'OK' : 'NG')
                                            : 'Not Done'}
                                    </Grid>
                                </Grid>

                            </React.Fragment>
                        ))}
                    </div>
                </Box>
                {/* <Box mb={2}>
                    <div className="checkpoint-box">
                        <Grid container spacing={3}>
                            <Grid item>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={addRow}>
                                    Add Row
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} alignItems='center'>
                            <Grid item xs={5}>
                                <h4>Spare</h4>
                            </Grid>
                            <Grid item xs={2}>
                                <h4>Stock</h4>
                            </Grid>
                            <Grid item xs={3}>
                                <h4>Quantity</h4>
                            </Grid>
                            <Grid item xs={2}>
                                <h4>Action</h4>
                            </Grid>
                        </Grid>
                        <hr />
                        {checkpoints.map((checkpoint, index) => (
                            <Grid container spacing={3} alignItems='center' key={index}>
                                <Grid item xs={5}>
                                    <TextField
                                        label="Spare"
                                        name="name"
                                        type="text"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={checkpoint.name}
                                        onChange={(e) => handleChange(index, 'name', e.target.value)}
                                    />

                                </Grid>
                                <Grid item xs={2}>
                                    <p>N/A</p>
                                </Grid>
                                <Grid item xs={3}>

                                    <Box className={classes.quantityBox}>
                                        <IconButton onClick={handleDecrease} size="small" className={classes.iconButton}>
                                            <Remove />
                                        </IconButton>
                                        <Typography variant="body1" className={classes.quantity}>
                                            {quantity}
                                        </Typography>
                                        <IconButton onClick={handleIncrease} size="small" className={classes.iconButton}>
                                            <Add />
                                        </IconButton>
                                    </Box>
                                </Grid>
                                <Grid item xs={2} >
                                    <DeleteIcon onClick={() => handleDelete(index)} />
                                </Grid>
                            </Grid>
                        ))}
                        <hr />

                    </div>
                </Box> */}
                <Box mb={1}>
                    <div className="checkpoint-box">
                        <Grid container spacing={3}>
                            <Grid item xs={2} sm={1}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={submitAllOk}
                                            name="enabled"
                                            color="primary"
                                            onClick={() => setsubmitAllOk(!submitAllOk)}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <p>Submit all as Ok</p>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    label="Start Date"
                                    name="startDate"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    required
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)} // Update start date state
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    id="time"
                                    label="Start time"
                                    type="time"
                                    defaultValue="00:00"
                                    // className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                    required
                                    value={startTime}
                                    onChange={(e) => setStartTime(e.target.value)} // Update start time state
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    label="End Date"
                                    name="endDate"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    required
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)} // Update end date state
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    id="time"
                                    label="End time"
                                    type="time"
                                    defaultValue="00:00"
                                    // className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                    required
                                    value={endTime}
                                    onChange={(e) => setEndTime(e.target.value)} // Update end time state
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} className='row1'>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    // label="Carried Out by"
                                    placeholder='Carried Out by'
                                    name="CarriedOutBy"
                                    type="text"
                                    size='small'
                                    variant="outlined"
                                    onChange={(e) => setcarriedOutName(e.target.value)}
                                    fullWidth
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Button
                                    // style={{ backgroundColor: '#3f51b5', color: 'white', width: "300px", marginLeft: "250px" }}
                                    // disabled={!submitAllOk}
                                    variant="contained"
                                    color='primary'
                                    fullWidth
                                    onClick={submitHandler}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </Box>
                {/* <div className="btn">
                    <Button
                        type="submit"
                        variant="contained"
                        style={{ backgroundColor: '#3f51b5', color: 'white', width: "300px", marginLeft: "250px" }}
                        // disabled={!submitAllOk}
                        onClick={submitHandler}
                    >
                        Submit
                    </Button>
                </div> */}
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default CheckPointActivity;
